import { useContext } from 'react'
import { AuthContext } from '../contexts/authContext'
import { sendEvent } from '../utils/hotmart-event'

const useHotmartEvent = () => {
  const { user } = useContext(AuthContext)
  const userId =  Number(localStorage.getItem('userId') || user?.profile?.id)

  const sendHotmartEvent = ({ entity, action, event }) => {
    event = { ...event, userId}
    
    if (userId) {
      try {
        sendEvent({
          entity,
          action,
          event
        })
      } catch (error) {
        throw new Error(`Failed sending hotmart event. ${error}`)
      }
    }
  }

  return {
    sendHotmartEvent
  }
}

export { useHotmartEvent }
